"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importDefault(require("react"));
const use_field_api_1 = __importDefault(require("@data-driven-forms/react-form-renderer/use-field-api"));
const FormField_1 = __importDefault(require("../../../FormField"));
const TimePicker_1 = __importDefault(require("../../../TimePicker"));
const useUniqueId_1 = __importDefault(require("../../../../hooks/useUniqueId"));
const getErrorText_1 = require("../../utils/getErrorText");
const TimePickerMapping = (props) => {
    const { label, description, helperText, isRequired, isDisabled, isReadOnly, placeholder, input, validateOnMount, stretch, showError, meta: { error, submitFailed }, } = use_field_api_1.default(props);
    const controlId = useUniqueId_1.default(input.name);
    const errorText = getErrorText_1.getErrorText(validateOnMount, submitFailed, showError, error);
    // Coerce value (ISO 8601 string) to Date. Handle invalid dates by setting to undefined
    const dateValue = new Date(input.value);
    const value = dateValue.toString() !== 'Invalid Date' ? dateValue : undefined;
    return (react_1.default.createElement(FormField_1.default, { controlId: controlId, label: label, description: description, hintText: helperText, errorText: errorText, stretch: stretch },
        react_1.default.createElement(TimePicker_1.default, Object.assign({}, input, { value: value, onChange: (date) => {
                // Coerce to a string for the formrenderer onChange event. Wrap in try catch in case user inputs invalid
                // time, eg 99:99.
                try {
                    input.onChange(date === null || date === void 0 ? void 0 : date.toISOString());
                }
                catch (e) {
                    input.onChange(undefined);
                }
            }, placeholder: placeholder, controlId: controlId, disabled: isDisabled, ariaRequired: isRequired, readOnly: isReadOnly }))));
};
exports.default = TimePickerMapping;
//# sourceMappingURL=index.js.map